import axios from "axios";
import { API_URL } from "../../constants";
import _ from "lodash";

export default {
  createUser: (data) => {
    return axios.post(API_URL.USER, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  userSetPassword: (data) => {
    return axios.post(API_URL.USER_SET_PASSWORD, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  getAllUser: (page, pageSize, sortBy, sort, searchparams) => {
    const filteredParams = _.pickBy(
      searchparams,
      (value) => !_.isNil(value) && value !== false && value !== ""
    );
    return axios.get(API_URL.USER_GET, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
      params: {
        username: filteredParams.username,
        mobile_number: filteredParams.mobile_number,
        role_uuid: filteredParams.role_uuid,
        status: filteredParams.status,
        page: page,
        pageSize: pageSize,
        sortBy: sortBy,
        sortOrder: sort,
      },
    });
  },
  getUserId: (id) => {
    return axios.get(`${API_URL.USER_GET_ID}/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  updateUser: (userid, roleid, data) => {
    console.log("log", userid, roleid, data);

    return axios.patch(`${API_URL.USER_GET}/${userid}/${roleid}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  userStatusUpdate: (userid, data) => {
    return axios.patch(`${API_URL.USER_GET}/${userid}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
};
